import { render, staticRenderFns } from "./FrameToComeInfo.vue?vue&type=template&id=3bbfda30"
import script from "./FrameToComeInfo.vue?vue&type=script&lang=js"
export * from "./FrameToComeInfo.vue?vue&type=script&lang=js"
import style0 from "./FrameToComeInfo.vue?vue&type=style&index=0&id=3bbfda30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports